import { WebSocketClient } from '@cabloy/socket';
import debounce from 'debounce';
import { BeanSimple } from 'zova';
export class MonkeySys extends BeanSimple {
  constructor(...args) {
    super(...args);
    this._ws = void 0;
    this._reload = void 0;
  }
  async sysReady() {
    if (!this.sys.config.ssr.hmr) return;
    const scopeConfig = this.sys.util.getModuleConfigSafe('a-ssrhmr');
    this._reload = debounce(() => {
      this._reloadInner();
    }, scopeConfig.change.debounce);
    this._startWs();
  }
  sysClose() {
    if (!this.sys.config.ssr.hmr) return;
    this._closeWs();
  }
  _closeWs() {
    if (this._ws) {
      this._ws.disconnect();
      this._ws = undefined;
    }
  }
  _startWs() {
    const ws = this._ws = new WebSocketClient({
      reconnectDelayMax: 1000
    });
    ws.onEvent = (eventName, _data) => {
      if (eventName === 'reload') {
        this._reload?.();
      }
    };
    ws.onOpen = (_event, reconnectAttempts) => {
      this.sys.meta.logger.get().log('silly', '[ssr hmr] ready');
      if (reconnectAttempts > 0) {
        this._reloadInner();
      }
    };
    // connect
    const url = `${this.sys.config.ws.baseURL}${this.sys.config.ws.prefix}/ssrhmr`;
    ws.connect(url);
  }
  async _reloadInner() {
    await this.sys.meta.event.emit('a-ssrhmr:reload');
  }
}